import ApiClient from "./apiClient";


const quotasService = {
  get:() => ApiClient.get('openstack/quotas'),
  createOpenstackUser:() => ApiClient.post('create_openstack')
}

export default quotasService